import React from 'react';
import PointIcon from '../../assets/point-icon.svg';
import PlusGreenIcon from '../../assets/plus-bold-icon.svg';
import CheckedIcon from '../../assets/checked-icon.svg';
import PointBoldIcon from '../../assets/point-bold-icon.svg';

const ReputationPointComponent = ({ reputationPoints, setOpenAwardWriterModal }) => {
  return (
    <div
      className={`flex gap-1 items-center py-1 px-2 border  ${reputationPoints?.given ? 'border-[#87C98A] bg-growth-green-200' : 'border-[#C8E6C9] bg-06-seasalt-white'} rounded-[80px] w-fit cursor-pointer hover:opacity-80`}
      onClick={() => setOpenAwardWriterModal(true)}
    >
      <img src={reputationPoints?.given ? PointBoldIcon : PointIcon} className="w-4 h-4" alt="" />
      <p
        className={`text-growth-green-900 font-[800] text-xs ${reputationPoints?.amount > 0 ? 'block' : 'hidden'}`}
      >
        {reputationPoints?.amount} {reputationPoints?.amount === 1 ? 'Twig' : 'Twigs'}
      </p>
      {reputationPoints?.given > 0 ||
        (reputationPoints?.amount > 0 ? (
          <></>
        ) : (
          <span className="text-xs font-[800] text-growth-green-900">Award</span>
        ))}

      {!!reputationPoints?.given ? (
        <img src={CheckedIcon} alt="" className="w-4 h-4" />
      ) : (
        <img src={PlusGreenIcon} alt="" className="w-4 h-4" />
      )}
    </div>
  );
};

export default ReputationPointComponent;
